import styled from "styled-components";
import { device } from "../utlis/device";

const ButtonContainer = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

`

const ButtonStyle = styled.button`
   border: none;
   font-size: 20px;
   font-family: inherit;
   padding: 15px;
   margin: 15px;
   border-radius: 15px;
   cursor: pointer;
   background-color: ${props => props.backgroundColor};
   color: #f5f0e5;
   z-index: 99999px;
   width: 120px;
   & a {
    color: #f5f0e5;
    text-decoration: none;
   }
   @media ${device.mobileL} {
     font-size: 18px;
  }
  @media ${device.mobileM} {
    font-size: 16px;
  }
  @media (max-width: 320px) {
    font-size: 14px;
  }
`



function Button(props) {
    // const question = useStore((state) => state.question)
    // const increaseQuestion = useStore((state) => state.increaseQuestion)

    return (

        <ButtonContainer>
          <ButtonStyle onClick={props.onClick} backgroundColor={props.backgroundColor}>{props.children}</ButtonStyle>
        </ButtonContainer>


    );
  }
  
  export default Button;